export default __webpack_public_path__ + "locales/es/SmartBanner.json?hash=c603bfd5cde53d2859f90d4ab0e76dba";